import { ContactForm } from '@/components/ContactForm/ContactForm';
import { Reveal } from '@/components/Reveal/Reveal';
import { Section } from '@/components/Section/Section';
import { CONTACT_DETAILS, HOME_CONTACT } from '@/dictionary/common';
import { HOME_ANCHORS } from '@/dictionary/routes';
import contactBackgroundUrl from '/assets/about-bg.mp4';
import classes from './ContactSection.module.css';

export function ContactSection() {
  return (
    <Section
      id={HOME_ANCHORS.contact.slice(1)}
      backgroundVideoUrl={contactBackgroundUrl}
      veilOpacity={0.62}
    >
      {/* סדר האלמנטים: הטופס ראשון ואחריו הפרטים — כך במקור,
          וב-RTL זה ממקם את הטופס בצד ימין ואת הפרטים משמאל. */}
      <div className={classes.grid}>
        <Reveal delaySeconds={0.12}>
          <ContactForm />
        </Reveal>

        <Reveal>
          <div className={classes.info}>
            <h2 className={classes.title}>{HOME_CONTACT.title}</h2>
            <p className={classes.lead}>{HOME_CONTACT.lead}</p>

            <div className={classes.details}>
              <div>
                <p className={classes.detailLabel}>{CONTACT_DETAILS.phoneLabel}</p>
                <a href={CONTACT_DETAILS.phoneHref} className={classes.detailValue} dir="ltr">
                  {CONTACT_DETAILS.phone}
                </a>
              </div>
              <div>
                <p className={classes.detailLabel}>{CONTACT_DETAILS.emailLabel}</p>
                <a href={CONTACT_DETAILS.emailHref} className={classes.detailValue} dir="ltr">
                  {CONTACT_DETAILS.email}
                </a>
              </div>
              <div>
                <p className={classes.detailLabel}>{CONTACT_DETAILS.addressLabel}</p>
                <p className={classes.detailValue}>{CONTACT_DETAILS.address}</p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </Section>
  );
}
